export default {
  SAVE_TABLE_DATA : "SAVE_TABLE_DATA",
  SET_PROCESS_SHIPPING_SEARCH_DATA:"SET_PROCESS_SHIPPING_SEARCH_DATA"
};
